import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

/**
 * Update note comment
 */
export default async function putNoteComment({
  note_data_id,
  note_comment,
}: {
  note_data_id: NoteData["note_data_id"];
  note_comment: NonNullable<NoteData["note_comment"]>;
}) {
  const res = await fetchOrchidAPI(
    `/api/notes_secure_data/v1/notes/data_comment/note_comment/${note_data_id}`,
    { method: "PUT", body: JSON.stringify({ note_comment }) },
  );
  if (!res.ok) {
    throw new Error(
      `failed to update note comment: ${getErrorDetail(await res.text())}`,
    );
  }

  return;
}
